import { Menu } from 'lucide-react'

import { cn } from '@/lib/utils'
import { Viewport } from './accountModel'
import { SignedInAvatar } from './SignedInAvatar'

interface AccountTopNavProps {
  viewport: Viewport
  /** Slot centred in the bar, independent of anything on either side. */
  center?: React.ReactNode
  className?: string
}

/**
 * The account's top bar: the profile avatar production puts in every page's
 * upper right, plus whatever a placement centres in the bar. Everything else
 * the live bar carries is left out, being page state this prototype has no
 * opinion about.
 */
export function AccountTopNav({ viewport, center, className }: AccountTopNavProps) {
  return (
    // Three tracks rather than a flex row, so the centre slot is centred on the
    // bar itself and stays centred whatever sits beside it.
    <div className={cn('grid w-full grid-cols-[1fr_auto_1fr] items-center gap-4 px-4 py-3', className)}>
      <div className="flex items-center">
        {viewport === Viewport.MOBILE && <Menu className="text-ink-300 size-4 shrink-0" />}
      </div>
      <div className="flex items-center justify-center">{center}</div>
      <div className="flex items-center justify-end">
        <SignedInAvatar />
      </div>
    </div>
  )
}
